import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/player.png'


const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4 custom-padding-30 pb-4" }
const _hoisted_2 = { style: {"margin-bottom":"20px"} }
const _hoisted_3 = {
  class: "audio-player",
  id: "audio_control"
}
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_5 = {
  id: "current-time",
  class: "fs-12"
}
const _hoisted_6 = {
  id: "duration",
  class: "fs-12"
}
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_8 = { class: "d-flex gap-1" }
const _hoisted_9 = {
  id: "audio",
  ref: "audio",
  src: "https://cldup.com/qR72ozoaiQ.mp3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 position-relative mb-3\" style=\"top:-5px;\"><h3 class=\"mb-0 fs-18 fw-semibold\">Player</h3><div class=\"dropdown action-opt right-for-rtl\" style=\"right:-8px;\"><button class=\"btn bg-transparent p-0 text-end\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-vertical\" style=\"stroke:#64748b;\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"clock\"></i> Today </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"pie-chart\"></i> Last 7 Days </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"rotate-cw\"></i> Last Month </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"calendar\"></i> Last 1 Year </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"bar-chart\"></i> All Time </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("img", {
        src: _imports_0,
        class: "rounded-3 d-lg-none w-100",
        alt: "player"
      }, null, -1)),
      _createElementVNode("div", {
        class: "bg-img rounded-3 d-none d-lg-block",
        style: _normalizeStyle([{
          backgroundImage: `url(${_ctx.image})`,
        }, {"background-position":"top center","height":"201px"}])
      }, null, 4)
    ]),
    _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center\" style=\"margin-bottom:20px;\"><div class=\"\"><h4 class=\"fs-14 fw-medium text-secondary mb-0\"> Building an Online Presence </h4><span class=\"fs-12\">Ethan Cooper</span></div><button class=\"favorite-button border-0 text-body-color-60 fs-14 bg-transparent p-0\"><span class=\"favorite-icon position-relative\"><i class=\"ri-heart-line fs-20\"></i><i class=\"ri-heart-fill fs-20 position-absolute top-50 start-50 translate-middle text-primary\"></i></span></button></div>", 1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentTime), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.duration), 1)
      ]),
      _createElementVNode("div", {
        class: "progress mb-3",
        style: {"height":"4px"},
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.seek && _ctx.seek(...args)))
      }, [
        _createElementVNode("div", {
          class: "progress-bar",
          id: "progress-bar",
          style: _normalizeStyle({ width: _ctx.progress + '%', height: '4px' })
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          id: "shuffle",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.shuffleTrack && _ctx.shuffleTrack(...args))),
          class: "bg-transparent p-0 lh-1 border-0",
          style: {"color":"#9caaff"}
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "ri-shuffle-line fs-20" }, null, -1)
        ]))]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            id: "rewind",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.skipTime(-10))),
            class: "bg-transparent p-0 lh-1 border-0",
            style: {"color":"#9caaff"}
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("i", { class: "ri-skip-left-fill fs-30" }, null, -1)
          ]))]),
          _createElementVNode("button", {
            id: "play-pause",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.playPause && _ctx.playPause(...args))),
            class: "p-0 lh-1 border-0 text-primary rounded-circle",
            style: {"background-color":"#ecf0ff","width":"44px","height":"44px"}
          }, [
            _createElementVNode("i", {
              class: _normalizeClass([_ctx.isPlaying ? 'ri-pause-fill' : 'ri-play-fill', "fs-30 position-relative"])
            }, null, 2)
          ]),
          _createElementVNode("button", {
            id: "fast-forward",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.skipTime(10))),
            class: "bg-transparent p-0 lh-1 border-0",
            style: {"color":"#9caaff"}
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "ri-skip-right-fill fs-30" }, null, -1)
          ]))])
        ]),
        _createElementVNode("button", {
          id: "restart",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.restart && _ctx.restart(...args))),
          class: "bg-transparent p-0 lh-1 border-0",
          style: {"color":"#9caaff"}
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("i", { class: "ri-reset-right-line fs-20" }, null, -1)
        ]))])
      ])
    ]),
    _createElementVNode("audio", _hoisted_9, null, 512)
  ]))
}